import React from 'react';

import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  PartnerDatatable = (props) => {

   const [t] = useTranslation();      
   const tableName = t('partner.label.'+props.partnerType+'s');
   const columns = [       
            { name: "Id", data: "id", selector: "id", omit: true},
            { name: t('general.label.name'), data: "address.name", sortable: true, selector: "address.name"},    		
            { name: t('user.label.firstName'), data: "address.firstName",  sortable: true,  selector: "address.firstName"},
            { name: t('user.label.lastName'), data: "address.lastName", sortable: true,  selector: "address.lastName"},
            { name: t('general.label.businessId'), data: "address.businessId", sortable: true,  selector: "address.businessId"},    		
            { name: t('general.label.street'), data: "address.street", sortable: true,  selector: "address.street"},         
            { name: t('general.label.city'), data: "address.city", sortable: true,  selector: "address.city"},
            { name: t('general.label.country'), data: "address.country.nameSk", sortable: true,  selector: "address.country.nameSk"},
            { name: t('user.label.mobilePhone'), data: "address.mobilePhone", sortable: true,  selector: "address.mobilePhone"},
            { name: t('user.label.officeEmail'), data: "address.officeEmail", sortable: true,  selector: "address.officeEmail"} 		
        ];        


        
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('general.label.name'), data: "address.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('user.label.firstName'), data: "address.firstName", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('user.label.lastName'), data: "address.lastName", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('general.label.businessId'), data: "address.businessId", orderable: true,  searchable: true, search: {value: '',regex: false}},    		
        { name: t('general.label.street'), data: "address.street",  orderable: true,  searchable: true, search: {value: '',regex: false}},     
        { name: t('general.label.city'), data: "address.city", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('general.label.country'), data: "address.country.nameSk", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('user.label.mobilePhone'), data: "address.mobilePhone",  orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('user.label.officeEmail'), data: "address.officeEmail",  orderable: true,  searchable: true, search: {value: '',regex: false}} 		
    ];        
    const url = RestService.getBaseURL()+"partner/getList?partnerType="+props.partnerType;  
    const urlExcel = RestService.getBaseURL()+"partner/getExcelPartners?partnerType="+props.partnerType;          
   
    const handleCallback  = (id) => {
            props.parentCallback(id);                   
    };
  
 
   
        return (
          
            <DataTableX
                url={url}  
                urlExcel={urlExcel}  
                tableName={tableName}
                columns={columns}   
                columnsData={columnsData}
                parentCallback={handleCallback}
                modalShow={props.modalShow}
            />
           /* <DataTable              
                parentCallback={handleCallback.bind(this)}
                ref={dataTableRef}               
                aoColumns={aoColumns}               
                url={url}                                
            />
           */
          
        );
   

 
};


export default PartnerDatatable;

